import { Component, Input, OnInit, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { DwMediaRepositoryService, DwRoMediaEntity, isFirstChange } from '@devwareapps/devware-cap';



@Component({
  selector: 'dw-image2',
  template: `
    <div [ngStyle]="containerStyle" *ngIf="!showGallery">
      <img [src]="src" [defaultSrc]="defaultSrc" [ngStyle]="imageStyle" [ngClass]="class" *ngIf="showImage" (click)="toggleShowGallery(true)"  />
    </div>
    <!--Gallery {{ currentMediaItems[0] | json }} {{ galleryStyle | json }} {{ galleryItem | json }} -->
     <ng-container *ngIf="showGallery">
        <p-galleria [value]="currentMediaItems" [(visible)]="showGallery" [activeIndex]="galleryIndex"
            (visibleChange)="toggleShowGallery($event)" [numVisible]="5"
            [fullScreen]="true" [showThumbnails]="false" [showIndicators]="false" [circular]="true"
            [showItemNavigators]="false" [baseZIndex]="10000">
            <ng-template pTemplate="item" let-item>
                <div [ngStyle]="galleryStyle2" style="overflow:hidden; text-align:center;" class="p-justify-center" (click)="toggleShowGallery(false)">
                    <img [src]="galleryItem?.src" [style]="galleryItem.imageStyle" />
                </div>
            </ng-template>
        </p-galleria>
    </ng-container>
  `
})
export class DwImage2Component implements OnInit, OnChanges {
  @Input() src: string;
  @Input() mediaId: number;
  @Input() mediaPath: string;

  @Input() defaultSrc: string;
  @Input() maxWidth: string;
  @Input() maxHeight: string;

  @Input() class: string;

  @Input() dwStyle: any;

  @Input() showAfterLoad: boolean = true;

  @Input() screenMargin: number = 20;

  @Input() allowFullScreen: boolean = false;

  currentMediaItems: { src: string, imageStyle: any }[] = [];
  galleryItem : { src: string, imageStyle: any };

  showImage: boolean = false;

  media: DwRoMediaEntity;
  imageSize: { height: number; width: number; };

  showGallery = false;
  galleryIndex = 0;
  galleryStyle: { width: string; height: string; };
  galleryStyle2: any;
  galleryImageStyle: any;

  constructor(private dwMediaRepository: DwMediaRepositoryService) { }

  imageStyle: any;
  containerStyle: any;

  lastSrc: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (!isFirstChange(changes)) {
      this.setupImage();
    }
  }

  ngOnInit(): void {
    this.setupImage();

    this.showImage = !this.showAfterLoad;
  }

  toggleShowGallery(value: boolean) {

    if (!this.allowFullScreen) {
      this.showGallery = false;
    }
    this.showGallery = value;
  }

  setupImage() {
    let width: number = null;
    let height: number = null;

    if (this.maxWidth) {
      width = parseInt(this.maxWidth.replace("px", ""));

      if (this.maxHeight?.indexOf("%") >= 0) {
        width = null;
      }
    }
    if (this.maxHeight) {
      height = parseInt(this.maxHeight.replace("px", ""));
    }


    if (this.mediaPath) {
      this.src = this.dwMediaRepository.getImageUrlFromMediaPath(this.mediaPath, width, height);
    }

    if (this.mediaId && !this.media) {
      this.dwMediaRepository.loadMedia(this.mediaId).subscribe(mediaItems => {
        this.media = mediaItems[0];

        this.src = this.dwMediaRepository.getImageUrlFromMediaPath(this.media?.MediaPath, width, height);

        this.setupImage();
      });

      return;
    }


    this.containerStyle = {
      // 'width': this.maxWidth || '100%',
      // 'height': this.maxHeight,
      'overflow': 'hidden'
    }

    this.imageStyle = {
      'width': this.maxWidth || '100%'
    }

    if (this.dwStyle) {
      this.imageStyle = this.dwStyle;
    }

    if (!this.src) {
      return;
    }

    if (this.lastSrc && this.src == this.lastSrc) {
      return;
    }

    this.lastSrc = this.src;

    const image = new Image();
    image.src = this.src;

    image.onload = (e: any) => {
      this.imageSize = this.getImageSize(e);

      this.finalImageSetup(this.imageSize);

      this.showImage = true;
    };

    // this.setupGallery();

  }


  finalImageSetupOld(imageSize: { height: number, width: number }) {

    if (!imageSize) {
      this.imageStyle = {
        'width': this.maxWidth || '100%'
      }
      return;
    }

    if (imageSize.width > imageSize.height) {
      this.imageStyle = {
        'width': this.maxWidth
      }
    } else {
      this.imageStyle = {
        'height': this.maxHeight
      }
    }

  }


  @HostListener('window:resize', ['$event'])
  public reset(event: any): void {
    // re-configure the grid style upon browser resize
    if (this.imageSize) {
      this.finalImageSetup(this.imageSize);
    }
  }


  finalImageSetup(imageSize: { height: number, width: number }) {
    let maxWidthNumber: any = this.parseDimension(this.maxWidth);
    let maxHeightNumber: any = this.parseDimension(this.maxHeight);


    const screenWidth = window.innerWidth - this.screenMargin;
    const screenHeight = window.innerHeight - this.screenMargin;

    const width = imageSize.width;
    const height = imageSize.height;


    this.setupGallery(width, height);

    // This was causing the image to be huge since it could be the same size as the screen (not sure why this was here)
    // if (height >= width && height > (screenHeight - this.screenMargin)) {
    //   this.imageStyle = {
    //     'height': '100%'
    //   }
    //   return
    // }

    if (maxHeightNumber && height > maxHeightNumber) {
      let adjustedWidth = (height / maxHeightNumber) * width;

      if (width > screenWidth) {

        let adjustedHeight = (screenWidth / width) * height;

        if (adjustedHeight < maxHeightNumber) {
          this.imageStyle = {
            'width': '100%'
          }
          return;
        }
      }

      if (!maxWidthNumber || adjustedWidth <= maxWidthNumber) {
        // Need to resize to fit height
        this.imageStyle = {
          'height': this.maxHeight,
          //'width': (height / maxHeightNumber) * width + "px"
        }
        return;
      }
      if (width >= height && width > (screenWidth - this.screenMargin)) {
        this.imageStyle = {
          'width': '100%'
        }

        return
      }
    }

    if (maxWidthNumber && width > maxWidthNumber) {
      this.imageStyle = {
        'width': this.maxWidth,
        //'width': (height / maxHeightNumber) * width + "px"
      }
      return;
    }

    // if we get here, then the image is smaller than the max width and height
    // so, we set either the width or height to the actual image width/height and we should be good
    this.imageStyle = {
      'width': imageSize.width + 'px'
    }

    // if (width > height) {
    //   this.width = this.maxWidth;
    //   this.height = null;
    // } else {
    //   this.height = this.maxHeight;
    //   this.width = null;
    // }

  }


  private setupGallery(width: number, height: number) {



    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // const galleryWidth = window.innerWidth > 1200 ? 1200 : window.innerWidth;
    // const galleryHeight = galleryWidth * 0.75;

    this.galleryStyle = { width: `${screenWidth}px`, height: `${screenHeight}px` };

    this.galleryItem = {
      src: this.src,
      imageStyle: this.getGaleryMediaStyle(width, height, screenWidth, screenHeight)
    };

    this.currentMediaItems = [this.galleryItem];
  }


  getGaleryMediaStyle(width: number, height: number, screenWidth: number, screenHeight: number) {

    let finalWidth = width;
    let finalHeight = height;

    if (finalWidth > finalHeight) {
      if (width > screenWidth) {
        finalWidth = (screenWidth - 100);
        finalHeight = (finalWidth * height / width);
      }
    }

    if (finalHeight > finalWidth) {
      if (height > screenHeight) {
        finalHeight = (screenHeight - 100);
        finalWidth = (finalHeight * width / height);
      }
    }

    return { width: `${finalWidth}px`, height:`${finalHeight}px`, diplay: 'block' };
    // if (height > width) {

    //   if (width > screenWith)
    //   const widthPercent = (width * 100 / height);

    //   return { width: `${widthPercent}%`, diplay: 'block' };
    // } 
    // else {
    //   const heightPercent = (height * 100 / width);

    //   return { height: `${heightPercent}%`, diplay: 'block' };
    // }

    // if (fullScreen) {
    //   return { height: '800px' };
    // }

    // return { width: '100%', diplay: 'block' };
  }

  parseDimension(dimension: string): number {

    if (dimension?.indexOf("px") > 0) {
      return parseInt(dimension.replace("px", ""));
    }

    return null;
  }

  private getImageSize(imageLoadEvent: any): { height: number, width: number } {
    const image = imageLoadEvent.currentTarget;

    if (!image) {
      return null;
    }

    return { height: image.height, width: image.width };
  }

}
